import * as React from "react";

// Canonical variant tokens live in `./status-variant-tokens` and are also
// re-exported by `@quovy/ui` so `StatusBadge` and this pill stay in sync.
import { STATUS_VARIANT_CLASS, type StatusVariant } from "./status-variant-tokens";

export type { StatusVariant };

const BASE_CLASS =
  "inline-flex items-center justify-center rounded-md border border-transparent px-2 py-0.5 text-xs font-medium w-fit whitespace-nowrap shrink-0 gap-1";

export interface StatusPillProps {
  variant: StatusVariant;
  children: React.ReactNode;
  className?: string;
}

export function StatusPill({ variant, children, className }: StatusPillProps) {
  const cls = [BASE_CLASS, STATUS_VARIANT_CLASS[variant], className].filter(Boolean).join(" ");
  return (
    <span data-slot="badge" className={cls}>
      {children}
    </span>
  );
}
